module.exports = __webpack_public_path__ + "img/foret.4ff8bd02.jpg";